import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import { MediaType } from '@types';
import { getUrlByMediaType } from '@utils/urlMakers';
import { $audioPlayer } from '@stores/audioPlayerStores';
import ImageContainer from '../ImageContainer';
import IconTrash from '../icons/IconTrash';
import ImgPlay from './img-play.png';
import ImgPause from './img-pause.png';
import { Validator } from '../Validator';

interface Props {
  mediaType?: MediaType;
  src?: string;
  name?: string;
  volume?: number;
  isRequired?: boolean;
  onDelete: () => void;
}

function AudioPlayer({
  mediaType = MediaType.lib,
  src = '',
  name,
  volume = 1,
  isRequired,
  onDelete,
}: Props) {
  const url = getUrlByMediaType(mediaType, src);
  const isPlaying = useStore($audioPlayer.$playingAudio) === url;
  useEffect(() => {
    $audioPlayer.setVolume(volume);
  }, [volume]);
  useEffect(() => {
    return () => {
      $audioPlayer.unmountAudio(url);
    };
  }, [url]);
  return (
    <Validator
      value={src}
      validFn={(value) => {
        if (!isRequired) return true;
        return !!value;
      }}
      warningMessage="请选择音频文件"
    >
      {({ value, warning }) => (
        <ImageContainer
          warning={warning}
          className="mt-10 h-70"
          placeholder="支持格式：MP3"
        >
          {!!value && (
            <div className="flex">
              <img
                className="h-40 w-40 cursor-pointer"
                draggable="false"
                src={isPlaying ? ImgPause : ImgPlay}
                alt=""
                onClick={() =>
                  $audioPlayer.playAudio(url, { volume, loop: false })
                }
              />
              <div className="ml-10">
                <div className="w-140 truncate text-base text-white">
                  {name}
                </div>
                <IconTrash onClick={onDelete} />
              </div>
            </div>
          )}
        </ImageContainer>
      )}
    </Validator>
  );
}

export default AudioPlayer;
